import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;

export const CATEGORY_LABELS = {
  honey: "Honey",
  cider: "Cider",
  "maple-syrup": "Maple Syrup",
  wine: "Wine",
  apparel: "Apparel",
};

export const formatPrice = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n || 0);
